module.exports = __webpack_public_path__ + "img/social-media-display-cjdr.730ed6fe.jpg";